module.exports = "<!-- <h2>Admin Interface</h2>\r\n<ul>\r\n  <li>\r\n    <a [routerLink]=\"['/admin/user-management']\"> Users </a>\r\n  </li>\r\n  <li>\r\n    <a [routerLink]=\"['/admin/report-management']\"> Report Management </a>\r\n  </li>\r\n</ul>\r\n<br/> -->\r\n<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main